import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Shimmer, SkeletonContainer } from "./styles";
export var Skeleton = forwardRef(function Skeleton(_a, ref) {
    var width = _a.width, height = _a.height, borderRadius = _a.borderRadius, props = __rest(_a, ["width", "height", "borderRadius"]);
    return (_jsx(SkeletonContainer, __assign({ ref: ref, style: __assign({ width: width, height: height, borderRadius: borderRadius }, props.style) }, props, { children: _jsx(Shimmer, {}) })));
});
//# sourceMappingURL=index.js.map